import { render, staticRenderFns } from "./CatalogoEstadosObras.vue?vue&type=template&id=10676fde"
import script from "./CatalogoEstadosObras.vue?vue&type=script&lang=js"
export * from "./CatalogoEstadosObras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports